import { useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "./Carte.css";

export default function Carte() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/buy-button.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
        document.body.removeChild(script);
        };
    }, []);

    return (
        <Container className="carteContainer worldwide">
            <p className="carteTitle">
                <span className="bracket">{'<'}</span>
                    Algoritmi și Rezolvări
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="carteSubTitle">Titularizare & Definitivat la disciplina Informatică și Tehnologia Informației</p>
            <Row className="text-center">
                <stripe-buy-button
                    buy-button-id="buy_btn_1SycBgPMXki8vJSyA2OJiZ99"
                    publishable-key="pk_live_51SaK9TPMXki8vJSyH58O3NS0OvrRynLstdaHX2XqugQGPnk7oiS22q5wU3vmDaWEUkt3kCWDBq5uuG34hxtFqE0800q96ksmxX"
                />
            </Row>
            <Row className="text-center" style={{marginTop: "25px"}}>
                <div>
                    <div className="carteCardsContainer">
                        <p className="carteSubTitle" style={{textAlign: "left"}}>
                            Informații
                        </p>
                        <div style={{ height: "2px", background: "rgba(78, 227, 157, 0.3)", width: "145px", marginBottom: "25px" }}></div>
                        <p className="carteDescription">
                            Materialul în format <span className="bold">fizic</span> este conceput special pentru
                            pregătirea eficientă a examenelor:
                        </p>
                        <ul className="infoList">
                            <li>
                                <span>Are un volum de <span className="bold">110 pagini</span>, fiind structurat
                                pentru o parcurgere rapidă.</span>
                            </li>
                            <li>
                                <span>Cuprinde <span className="bold">toți algoritmii</span> solicitați de programa de
                                Titularizare și Definitivat.</span>
                            </li>
                            <li>
                                <span>Include <span className="bold">toate rezolvările</span> problemelor de programare
                                din ultimii <span className="bold">11 ani (2015-2025)</span>.</span>
                            </li>
                            <li>
                                <span>Prețul este de <span className="bold">85 RON</span> + transport.</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </Row>
            <Row className="justify-content-center" style={{ marginTop: "25px" }}>
                <Col xs={12} md={8} lg={6}> 
                    <p className="meditatiiSubTitle" style={{ textAlign: "center" }}>Cuprinsul Materialului</p>
                    <div className="carteCardsContainer" style={{ padding: "10px", marginTop: "15px" }}>
                        <div className="pdfWrapper">
                            <iframe 
                                src="/carte/cuprins-algoritmi-rezolvari.pdf#toolbar=0&navpanes=0" 
                                width="100%" 
                                height="600px" 
                                title="Cuprins Material"
                                className="pdfViewer"
                                style={{ border: "none", borderRadius: "10px" }}
                            >
                            </iframe>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className="justify-content-center" style={{ marginTop: "25px" }}>
                <Col xs={12} md={6} lg={6}> 
                    <p className="carteSubTitle">Prezentare Video</p>
                    <div className="carteCardsContainer videoCardCustom">
                        <div className="videoWrapperVertical">
                            <video controls className="videoElement" muted>
                                <source src="/carte/video-algoritmi-rezolvari.mp4" type="video/mp4" />
                                Browserul tău nu suportă redarea video.
                            </video>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className="text-center">
                <stripe-buy-button
                    buy-button-id="buy_btn_1SycBgPMXki8vJSyA2OJiZ99"
                    publishable-key="pk_live_51SaK9TPMXki8vJSyH58O3NS0OvrRynLstdaHX2XqugQGPnk7oiS22q5wU3vmDaWEUkt3kCWDBq5uuG34hxtFqE0800q96ksmxX"
                />
            </Row>
        </Container>
    )
}